import { ViewModel } from './model';
import html from './template.html';
import './style.less';

if (!ko.components.isRegistered('success-message')) {
  ko.components.register('success-message', {
    viewModel: {
      createViewModel: (params, componentInfo) => {
        let element = componentInfo.element;
        let $element = $(element);

        return new ViewModel(params, element);
      },
    },
    template: html,
  });
}
